/**
 * Get the base URL for the API
 */
export const getApiBaseUrl = (): string => {
  return process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
};

/**
 * Convert a relative image path to a full API URL
 * @param relativePath - Path like "uploads/portal-candidates/image.jpg"
 * @returns Full URL like "https://hub.242network.com/api/images/portal-candidates/filename.jpg"
 */
export const getImageUrl = (
  relativePath: string | null | undefined,
  options?: {
    width?: number;
    height?: number;
    quality?: number;
    format?: 'webp' | 'jpeg' | 'png';
  }
): string | undefined => {
  if (!relativePath) return undefined;
  
  // Extract the filename from the path
  // Path format: "uploads/portal-candidates/filename.jpg" or "/uploads/portal-candidates/filename.jpg"
  const cleanPath = relativePath.startsWith('/') ? relativePath.substring(1) : relativePath;
  
  // Parse the path to get category and filename
  const parts = cleanPath.split('/');
  
  if (parts.length >= 3 && parts[0] === 'uploads') {
    // Path format: uploads/portal-candidates/filename.jpg
    const category = parts[1]; // e.g., "portal-candidates"
    const filename = parts.slice(2).join('/'); // e.g., "filename.jpg"
    
    const apiUrl = getApiBaseUrl();
    const params = new URLSearchParams();
    if (options?.width) params.set('w', String(options.width));
    if (options?.height) params.set('h', String(options.height));
    if (options?.quality) params.set('q', String(options.quality));
    if (options?.format) params.set('format', options.format);
    const query = params.toString();
    return `${apiUrl}/images/${category}/${filename}${query ? `?${query}` : ''}`;
  }
  
  // Fallback: return as-is (shouldn't happen with correct data)
  console.warn(`Unexpected image path format: ${relativePath}`);
  const apiUrl = getApiBaseUrl();
  const params = new URLSearchParams();
  if (options?.width) params.set('w', String(options.width));
  if (options?.height) params.set('h', String(options.height));
  if (options?.quality) params.set('q', String(options.quality));
  if (options?.format) params.set('format', options.format);
  const query = params.toString();
  return `${apiUrl}/${cleanPath}${query ? `?${query}` : ''}`;
};
